import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { INotify } from "../../model/user-info.interface";
import { INotificationsState } from ".";

export interface IMarkNotifyAsReadResponse {
    notifyId: number;
}

export const markNotifyAsRead = createAsyncThunk<IMarkNotifyAsReadResponse, INotify>(
    'notifications/markNotifyAsRead',
    async (notify: INotify) => await api.notifications.markNotifyAsRead(notify.id, notify.type)
);

const markNotifyAsReadHandler = (builder: ActionReducerMapBuilder<INotificationsState>) => {
    builder
        .addCase(markNotifyAsRead.pending, (state: INotificationsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(markNotifyAsRead.fulfilled, (state: INotificationsState, action: PayloadAction<IMarkNotifyAsReadResponse>) => {
            state.loading = false;
            state.items = state.items.filter(notify => notify.id !== action.payload.notifyId);
        })
        .addCase(markNotifyAsRead.rejected, (state: INotificationsState) => {
            state.loading = false;
            state.error = 'Unable to mark notify as read';
        });
};

export default markNotifyAsReadHandler;